import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Grid, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import useHirePortContext from '@/hooks/useHirePortContext';

import { useNavSider } from './NavSiderContext';

/**
 * Prefix control for the app navigation sider — same pattern as
 * FilteredListingFilterSidebarToggle (custom trigger, collapsible Layout.Sider).
 * Hidden on embed and when Layout does not provide nav sider context.
 */
export function NavSiderToggle() {
  const { t } = useTranslation();
  const { renderPageHeader } = useHirePortContext();
  const navSider = useNavSider();
  const screens = Grid.useBreakpoint();

  const isMobile = !screens.md;

  if (!renderPageHeader || navSider == null || !isMobile) {
    return null;
  }

  const { collapsed, toggle } = navSider;
  const label = collapsed ? t('EXPAND_NAVIGATION') : t('COLLAPSE_NAVIGATION');

  return (
    <Tooltip title={label}>
      <Button
        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        aria-label={label}
        data-testid="app-navigation-sider-toggle"
        onClick={toggle}
      />
    </Tooltip>
  );
}
